<div class="sk-cms-file pc-email {{isPreview ? '': 'sk-component FILE'}}"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
    {{if style.isShowTitle == '1'}}
        <% include('../common/title.art', {title: basic.title}) %>
    {{/if}}

    {{if !content.items || !content.items.length}}
         <% include('../common/nodata.art') %>
    {{else}}
    {{if style.moreStyle.styleType != 'hide' && isMain != 1}}
    <div class="sk-cms-more">

            <div class="more sk-cms-more-dom">
                {{if isDesign}}
                    <span class="more-btn {{style.moreStyle.styleType == 'default'?'medium':style.moreStyle.fontSize}}" style="{{style.moreStyle.styleType == 'default' ? '': 'color:' + style.moreStyle.color}}">MORE >></span>
                {{else}}
                    <a class="more-btn goto-link {{style.moreStyle.styleType == 'default'?'medium':style.moreStyle.fontSize}}" style="{{style.moreStyle.styleType == 'default' ? '': 'color:' + style.moreStyle.color}}" href="{{isPreview ? content.moreLink: content.morePage}}">MORE >></a>
                {{/if}}
            </div>

    </div>
{{/if}}
    <div class="file-main {{basic.style.type}} {{basic.columns.type}}">
    {{each content.items}}
        <div class="file-items {{style.lineStyle.model === 'custom' ? style.lineStyle.line : ''}} {{style.lineStyle.model === 'hide' ? 'hide': ''}}"
            {{if style.lineStyle.model === 'custom'}}
            style="border-color: {{style.lineStyle.color}}"
            {{/if}}>
            <div class="file-img">
                <img src="{{$value.imgUrl ? $value.imgUrl : '../../assets/images/img_default.jpg'}}" cms-smarket/>
            </div>
            <div class="file-con">
                {{if style.titleStyle.styleType !== 'hide'}}
                <div class="file-title {{ style.titleStyle.styleType === 'custom' ? style.titleStyle.fontSize : ''}}"
                     style="{{style.titleStyle.styleType === 'custom' ? ('color:' + style.titleStyle.color) : ''}}" title="{{$value.title}}">
                    {{$value.title}}
                </div>
                {{/if}}
                <div class="file-bottom">
                    {{if style.timeStyle.styleType !== 'hide'}}
                    <div class="file-time {{ style.timeStyle.styleType === 'custom' ? style.timeStyle.fontSize : ''}}"
                         style="{{style.timeStyle.styleType === 'custom' ? ('color:' + style.timeStyle.color) : ''}}">
                        {{$value.pushTime}}
                    </div>
                    {{/if}}
                    <div class="button-bar">
                        {{if style.previewButton.styleType !== 'hide'}}
                        <div class="file-down preview {{ style.previewButton.styleType === 'custom' ? style.previewButton.fontSize : ''}}"
                            {{if style.previewButton.styleType === 'custom'}}
                            style="{{'color:' + style.previewButton.color}}; background-color:{{style.previewButton.backgroundColor}}; background-image: url('{{style.previewButton.imgUrl}}')"
                            {{/if}}
                        >
                        {{if !isDesign}}
                            {{if !isPreview}}
                            <a href="{{$value.link?$value.link:'javascript:void(0)'}}">{{content.previewText?content.previewText:'预览'}}</a>
                            {{else}}
                                {{if content.type == 1}}
                                <a href="{{$value.link?$value.link:'javascript:void(0)'}}">{{content.previewText?content.previewText:'预览'}}</a>
                                {{else}}
                                    {{if $value.preview.type == 2}}
                                        <a sk-prop.href="$data.fileDetail +  '&fid=' + {{$value.id}}">预览</a>
                                        {{/if}}
                                        {{if $value.preview.type == 3}}
                                        <a href="{{$value.wapPreviewUrl.replace('filePreview','fileDetail')}}">预览</a>
                                        {{/if}}
                                        {{if $value.preview.type == 1}}
                                        <a href="{{$value.wapPreviewUrl}}">预览</a>
                                        {{/if}}
                                {{/if}}
                            {{/if}}
                        {{else}}
                        <span>{{content.previewText?content.previewText:'预览'}}</span>
                        {{/if}}
                        </div>
                        {{/if}}

                        {{if style.button.styleType !== 'hide'}}
                        <div class="file-down {{ style.button.styleType === 'custom' ? style.button.fontSize : ''}}"
                            {{if style.button.styleType === 'custom'}}
                            style="{{'color:' + style.button.color}}; background-color:{{style.button.backgroundColor}}; background-image: url('{{style.button.imgUrl}}')"
                            {{/if}}
                            >
                            {{if !isDesign}}
                            <a cms-value-raw sk-event.click='downLoad({{content.type}}, {{$value}}, {{id}})'
                            href="javascript:void(0);">{{content.buttonText}}</a>
                            {{else}}
                            <span>{{content.buttonText}}</span>
                            {{/if}}
                        </div>
                        {{/if}}
                    </div>
                </div>
            </div>
        </div>
    {{/each}}
    </div>
    {{/if}}
    {{if isMain == 1}}
        <% include('../common/pagination.art') %>
    {{/if}}
    <% include('../common/email.art') %>
</div>
